import {
  onboardingBookingDestinationSchema,
  onboardingBookingProductSchema,
} from "@redotech/redo-onboarding-api/booking-destination";
import * as z from "zod";

export const getOnboardingBookingDestination = {
  name: "getOnboardingBookingDestination" as const,
  input: z.object({ productId: onboardingBookingProductSchema }),
  output: onboardingBookingDestinationSchema,
};

export const getOnboardingBookingDestinations = {
  name: "getOnboardingBookingDestinations" as const,
  input: z.object({}),
  output: z.object({
    destinations: z.array(onboardingBookingDestinationSchema),
  }),
};

export const setOnboardingBookingDestination = {
  name: "setOnboardingBookingDestination" as const,
  input: onboardingBookingDestinationSchema,
  output: onboardingBookingDestinationSchema,
};
